import { alias } from '@ember/object/computed';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  email: validator('format', {
    type: 'email',
    allowBlank: true,
  }),
  name: validator('presence', true),
  partnerType: [validator('belongs-to'), validator('presence', true)],
});

export default class MediaPartnerModel extends Model.extend(Validations) {
  @attr('string') city;
  @attr('string') cityEn;
  @attr('boolean') dgg;
  @attr('string') email;
  @attr('string') name;
  @attr('string') phone;
  @attr('string') street;
  @attr('string') zipcode;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('category', { async: true, inverse: null }) country;
  @belongsTo('link', { async: true, inverse: null }) link;
  @belongsTo('category', { async: true, inverse: null }) partnerType;
  @belongsTo('category', { async: true, inverse: null }) region;

  // Getter, setter and computed properties
  @alias('name') displayHeadline;
  @alias('name') displayLabel;
}
